//-----------------
import React, { useState, useEffect } from 'react';
import { State, City } from "country-state-city";
import '../Styles/RegisterAdmin.css';
import axios from 'axios';

const RegisterAdmin = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    fullName: '',
    phoneNumber: '',
    whatsappNumber: '',
    emailAddress: '',
    referredBy: '',
    country: 'India',
    state: '',
    district: '',
    city: '',
    address: '',
    locality: '',
    primaryBusiness: '',
    secondaryBusiness: '',
    pincode: '',
    nearestAirport: '',
    monthlyBusiness: '',
    secondaryMonthlyBusiness: '',
    panFile: null,
    gstFile: null,
    onlineOTAs: '',
    seriesOTAs: '',
  });
  // const [setIsSubmitting] = useState(false);
  // const [ setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
const [message, setMessage] = useState('');

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  
  useEffect(() => {
    // Fetch all countries on component mount
    const countryStates = State.getStatesOfCountry("IN");
    setStates(countryStates);
  }, []);

  const handleStateChange = (e) => {
    const selectedStateCode = e.target.value;

    // Update form data
    setFormData({ ...formData, state: selectedStateCode, city: "" });

    // Fetch cities for the selected state
    if (selectedStateCode) {
      const stateCities = City.getCitiesOfState("IN",selectedStateCode);
      setCities(stateCities);
    } else {
      setCities([]);
    }
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData((prevFormData) => ({ ...prevFormData, city: selectedCity }));
  }
  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  // Handle file change
  const handleFileChange = (event) => {
    const { name, files } = event.target; // Get the name of the input field and selected files
    const file = files[0];  // Get the first selected file

    setFormData({
      ...formData,
      [name]: file ? file : null, // Dynamically update the correct file (panFile or gstFile)
    },);
  };


  const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  setMessage('');

  // // ✅ File validation
  // if (!formData.panFile || !formData.gstFile) {
  //   alert("Both PAN and GST files are required.");
  //   setIsSubmitting(false);
  //   return;
  // }

  // ✅ Prepare FormData
  const submitData = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    if (value !== null && value !== undefined) {
      submitData.append(key, value);
    }
  });

  try {
    const response = await axios.post(
      'https://b2bbackendapi.mmstourism.com/api/b2/b2b.rou.g5c6y4/x1a2b3c46',
      submitData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.status === "FAILURE") {
      alert(response.data.message || "Registration failed.");
    } else {
      alert("Registration successful!");
      setFormData({
        companyName: '',
        fullName: '',
        phoneNumber: '',
        whatsappNumber: '',
        emailAddress: '',
        referredBy: '',
        country: 'India',
        state: '',
        district: '',
        city: '',
        address: '',
        locality: '',
        primaryBusiness: '',
        secondaryBusiness: '',
        pincode: '',
        nearestAirport: '',
        monthlyBusiness: '',
        secondaryMonthlyBusiness: '',
        panFile: null,
        gstFile: null,
        onlineOTAs: '',
        seriesOTAs: ''
      });
    }

  } catch (error) {
    console.error("API Error:", error);
    alert("Server error or agency may already exist.");
  } finally {
    setIsSubmitting(false);
  }
};

  
  
  return (
    <div className="register-body">
       <img
    src={require("../Images/logo1.png")}
    alt="MMS Tourism"
    className="register-logo"
    onClick={() => window.location.href = "/"} // optional: go back to login
  />
      <div className="registration-form">
        <h2>Agency Sign Up Form</h2>
        <p className="note">Fields marked with <span className="required">*</span> are mandatory</p>
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-register-group">
              <label>Company Name <span className="required">*</span></label>
              <input type="text" name="companyName" value={formData.companyName} placeholder='Company Name' onChange={handleInputChange} required />
            </div>
            <div className="form-register-group">
              <label>Full Name <span className="required">*</span></label>
              <input type="text" name="fullName" value={formData.fullName} placeholder='Full Name' onChange={handleInputChange} required />
            </div>
          </div>

          {/* Additional Rows for each form group */}
          <div className="form-row">
            <div className="form-register-group">
              <label>Phone Number <span className="required">*</span></label>
              <input type="text" name="phoneNumber" value={formData.phoneNumber} placeholder='Phone Number' onChange={handleInputChange} required />
            </div>
            {/* <div className="form-register-group">
              <label>WhatsApp Number <span className="required">*</span></label>
              <input type="text" name="whatsappNumber" value={formData.whatsappNumber} placeholder='WhatsApp Number' onChange={handleInputChange} required />
            </div>
          </div> */}

          {/* <div className="form-row"> */}
            <div className="form-register-group">
              <label>Email Address <span className="required">*</span></label>
              <input type="email" name="emailAddress" value={formData.emailAddress} placeholder='Email Address' onChange={handleInputChange} required />
            </div>
            {/* <div className="form-register-group">
              <label>Referred By <span className="required">*</span></label>
              <select name="referredBy" value={formData.referredBy} onChange={handleInputChange} required>
                <option value="">Select</option>
                <option value="agency">Agency</option>
                <option value="website">Website</option>
                {/* Add other options 
              </select>
            </div>
          </div>

            <div className="form-row">
            <div className="form-register-group">
              <label>Country <span className="required">*</span></label>
              <input type="text" name="country" value="India" placeholder="Country" readOnly />
            </div>
            <div className="form-register-group">
              <label>State <span className="required">*</span></label>
              <select type="text" name="state" value={formData.state} onChange={handleStateChange} required >
                
                <option value="">Select State</option>
                {states.map((state) => (
                  <option key={state.isoCode} value={state.isoCode}>
                    {state.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-register-group">
              <label>City <span className="required">*</span></label>
              <select name="city" value={formData.city} onChange={handleCityChange} required>
               
                <option value="">Select City</option>
                {cities.map((city) => (
                  <option key={city.name} value={city.name}>
                    {city.name}
                  </option>
                ))}
              </select> 
            </div>
          </div>
          
          <div className="form-row">
            <div className="form-register-group">
              <label>Address <span className="required">*</span></label>
              <input type="text" name="address" value={formData.address} placeholder='Address'onChange={handleInputChange} required />
            </div>
            <div className="form-register-group">
              <label>Specify your locality <span className="required">*</span></label>
              <input type="text" name="locality" value={formData.locality} placeholder='Locality'onChange={handleInputChange} required />
            </div>
            <div className="form-register-group">
              <label>Pincode <span className="required">*</span></label>
              <input type="number" name="pincode" value={formData.pincode} placeholder='PIN Code'onChange={handleInputChange} required />
            </div>
          </div>

          <div className="form-row">
            <div className="form-register-group">
              <label>Primary Business<span className="required">*</span></label>
              <select type="text" name="primaryBusiness" value={formData.primaryBusiness} onChange={handleInputChange} required >
                <option value = "">Select Primary Business Type</option>
                <option value = "Flight Ticket">Flight Ticket</option>
                <option value = "Railway Ticket">Railway Ticket</option>
                <option value = "Domestic Tour">Domestic Tour</option>
                <option value = "International Tour">International Tour</option>
              </select>
            </div>
            <div className="form-register-group">
              <label>Monthly Business 
                <span className="required">*</span>
              </label>
              <select name="monthlyBusiness" value={formData.monthlyBusiness} onChange={handleInputChange} required >
                <option value ="">Select</option>
                <option value ="Below 5 lacs">Below 5 Lacs</option>
                <option value ="5 - 10 Lacs">5 - 10 Lacs</option>
                <option value ="11 - 25 Lacs">11 - 25 Lacs</option>
                <option value ="Above 25 Lacs">Above 25 Lacs</option>
              </select>
            </div>
          </div>

          <div className="form-row">
            <div className="form-register-group">
              <label>Secondary Business
                <span className="required">*</span> 
                </label>
              <select type="text" name="secondaryBusiness" value={formData.secondaryBusiness} onChange={handleInputChange}>
                <option value = "">Select Secondary Business Type</option>
                <option value = "Flight Ticket">Flight Ticket</option>
                <option value = "Railway Ticket">Railway Ticket</option>
                <option value = "Domestic Tour">Domestic Tour</option>
                <option value = "International Tour">International Tour</option>
                <option value = "none">None</option>
              </select>
            </div>
            <div className="form-register-group">
              <label>Monthly Business
                 {/* <span className="required">*</span> 
                 </label>
              <select name="secondaryMonthlyBusiness" value={formData.secondaryMonthlyBusiness} onChange={handleInputChange}  >
                <option value ="">Select</option>
                <option value ="Below 5 lacs">Below 5 Lacs</option>
                <option value ="5 - 10 Lacs">5 - 10 Lacs</option>
                <option value ="11 - 25 Lacs">11 - 25 Lacs</option>
                <option value ="Above 25 Lacs">Above 25 Lacs</option>
              </select>
            </div>
          </div>

           PAN, GST, and OTAs sections 
          <div className="form-row">
            <div className="form-register-group">
              <label>PAN No.<span className="required">*</span></label>
              <div className="file-input-container">
                <div className="choose-file-container">
                  <span className="file-name">{formData.panFile ? formData.panFile.name : "No file selected"}</span>
                </div>
                <label className="custom-file-label" htmlFor="pan-upload">
                  Choose File
                </label>
                <input
                  id="pan-upload"
                  type="file"
                  name="panFile"
                  onChange={handleFileChange}
                  required
                />
              </div>
            </div>
            <div className="form-register-group">
              <label>Company GST No.<span className="required">*</span></label>
              <div className="file-input-container">
                <div className="choose-file-container">
                  <span className="file-name">{formData.gstFile ? formData.gstFile.name : "No file selected"}</span>
                </div>
                <label className="custom-file-label" htmlFor="gst-upload">
                  Choose File
                </label>
                <input
                  id="gst-upload"
                  type="file"
                  name="gstFile"
                  onChange={handleFileChange}
                  required
                />
              </div>
            </div>
          </div>

          <div className="form-row">
            <div className="form-register-group">
              <label>Online OTAs you are working with? </label>
              <input type="text" name="onlineOTAs" value={formData.onlineOTAs} placeholder='Online OTA1' onChange={handleInputChange} />
            </div>
            <div className="form-register-group">
              <label>Series OTAs you are working with? </label>
              <input type="text" name="seriesOTAs" value={formData.seriesOTAs} placeholder='Series OTA1' onChange={handleInputChange} />
            </div>*/}
          </div> 

          <button type="submit" className="submit-button">Submit</button>
        </form>
      </div>
    </div>
  );
};

export default RegisterAdmin;
